function Footer() {
  return (
    <footer className="app__footer text-center">
      <p className="pb-3 mb-0 app-fs-10">© Majestic Resorts 2024 l Política de privacidad y cookies</p>
    </footer>
  );
}

export default Footer;
